import { motion } from 'framer-motion';

export type HealthStatus = 'green' | 'yellow' | 'red';

const COLORS: Record<HealthStatus, string> = {
  green: '#22c55e',
  yellow: '#eab308',
  red: '#ef4444',
};

interface HealthBadgeProps {
  status: HealthStatus;
  size?: number;
}

export function HealthBadge({ status, size = 8 }: HealthBadgeProps) {
  return (
    <motion.div
      className="rounded-full flex-shrink-0"
      style={{
        width: size,
        height: size,
        backgroundColor: COLORS[status],
      }}
      animate={status === 'red' ? { opacity: [1, 0.4, 1] } : {}}
      transition={status === 'red' ? { duration: 1.2, repeat: Infinity } : {}}
    />
  );
}
